import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  requested: {
    description: 'Fulfillment Planner requested',
    defaultMessage: 'Requested',
    id: 'TT6vpm',
  },
  shipFrom: {
    description: 'Fulfillment Planner ship from',
    defaultMessage: 'Ship From',
    id: 'qM0kPh',
  },
  confirmation: {
    description: 'Fulfillment Planner confirmation',
    defaultMessage: 'Confirmation',
    id: 'kV98pQ',
  },
  insurance: {
    description: 'Fulfillment Planner insurance',
    defaultMessage: 'Insurance',
    id: 'eXWsEd',
  },
  delegationDate: {
    description: 'Delegation date field label placed on order details and order sidebar in shipment section',
    defaultMessage: 'Delegation Date',
    id: 'N7VNaf',
  },
  shipDate: {
    description: 'Fulfillment Planner ship date',
    defaultMessage: 'Ship Date',
    id: '3EBntB',
  },
  deliveryTime: {
    description: 'Fulfillment Planner delivery time',
    defaultMessage: 'Delivery Time',
    id: 'fNeS+f',
  },
  createLabel: {
    description: 'Fulfillment Planner create label',
    defaultMessage: 'Create Label',
    id: 'gaS226',
  },
  useScale: {
    description: 'Fulfillment Planner use scale',
    defaultMessage: 'Use Scale',
    id: 'Gg8NhD',
  },
  package: {
    description: 'Fulfillment Planner package',
    defaultMessage: 'Package',
    id: 'VL7tMO',
  },
  size: {
    description: 'Fulfillment Planner size',
    defaultMessage: 'Size',
    id: '9N+Rxm',
  },
  carrier: {
    description: 'Fulfillment Planner Carrier',
    defaultMessage: 'Carrier',
    id: '8zh1wv',
  },
  rate: {
    description: 'Fulfillment Planner Rate',
    defaultMessage: 'Rate:',
    id: 'M1rb+C',
  },
  insureAmt: {
    description: 'Fulfillment Planner Insure Amt',
    defaultMessage: 'Insure Amt',
    id: '1SF0Nw',
  },
  weight: {
    description: 'Fulfillment Planner Weight',
    defaultMessage: 'Weight',
    id: '8h94vh',
  },
  trackingNum: {
    description: 'Fulfillment Planner Tracking #',
    defaultMessage: 'Tracking #',
    id: 'OMfeC1',
  },
  tracking: {
    description: 'Fulfillment Planner Tracking Label',
    defaultMessage: 'Tracking',
    id: 'UPfMLu',
  },
  status: {
    description: 'Fulfillment Planner Status',
    defaultMessage: 'Status',
    id: '08mliA',
  },
  service: {
    description: 'Fulfillment Planner Service',
    defaultMessage: 'Service',
    id: 'hhh1GR',
  },
  returnTo: {
    description: 'Fulfillment Planner Return To',
    defaultMessage: 'Return To',
    id: 'iwY+14',
  },
  providerStatus: {
    description: 'Fulfillment Planner Provider Status Label',
    defaultMessage: 'Provider Status',
    id: 'BWPaua',
  },
  providerStatusPickupUp: {
    description: 'Fulfillment Planner Provider Status Action',
    defaultMessage: 'Picking Up',
    id: 'R8oPZH',
  },
  requestedService: {
    description: 'Fulfillment Planner Requested Service Label',
    defaultMessage: 'Requested Service',
    id: 'G62MBz',
  },
  requestedServiceLocalDelivery: {
    description: 'Fulfillment Planner Requested Service Action',
    defaultMessage: 'Local Delivery',
    id: '+cJ4nI',
  },
  localPickupTime: {
    description: 'Fulfillment Planner Local Pickup Time Label',
    defaultMessage: 'Pickup',
    id: 'M9Gwib',
  },
  localDeliveryTime: {
    description: 'Fulfillment Planner Local Delivery Time Label',
    defaultMessage: 'Delivery',
    id: 'OO414n',
  },
  driverTip: {
    description: 'Fulfillment Planner Driver Tip Label',
    defaultMessage: 'Driver Tip',
    id: 'UjRQqw',
  },
  totalCost: {
    description: 'Fulfillment Planner Formatted Total Cost Label',
    defaultMessage: 'Total Cost',
    id: 'ZnIvcv',
  },
  formattedTotalCost: {
    description: 'Fulfillment Planner Formatted Total Cost Label and currency',
    defaultMessage: 'Total Cost: {formattedTotalCost}',
    id: 'ZbKxXB',
  },
  manageDeliveryChangesText: {
    description: 'Fulfillment Planner Manage Local Delivery Helper Text with Link',
    defaultMessage: 'For assistance with your delivery please contact {carrierName} support via phone {phone} or email {email}.',
    id: 'UCHbBn',
  },
  trackOnUber: {
    description: 'Fulfillment Planner Manage Local Delivery Tracking Action Text (Call to action)',
    defaultMessage: 'Track on Uber',
    id: 'uQPy6L',
  },
  markShipped: {
    description: 'FulfillmentPlanner Mark as Shipped button action text',
    defaultMessage: 'Marked as Shipped',
    id: 'iUVKKZ',
  },
  pickupTime: {
    description: 'Fulfillment Planner Pickup Time',
    defaultMessage: 'Pickup Time',
    id: 'ov9BjM',
  },
  pickupInfoSectionHeader: {
    description: 'Fulfillment Planner Pickup Information',
    defaultMessage: 'Pickup Information',
    id: 'bt/Wt6',
  },
  serviceCollection: {
    description: 'Fulfillment Planner Rate Shopper Row',
    defaultMessage: 'Rate Shopper',
    id: 'RlsRiw',
  },
  dutiesAndTaxes: {
    description: 'Fulfillment Planner Duties/Taxes Row Label',
    defaultMessage: 'Duties/Taxes',
    id: 'JvY+ig',
  },
  returnErrorLabel: {
    description: 'Fulfillment Planner Return Error Label',
    defaultMessage: 'Return Error',
    id: '7/+aQg',
  },
  rateErrorBody: {
    description: 'Fulfillment Planner Return Error Body',
    defaultMessage: 'A problem occurred while creating a return label',
    id: '1i/vEM',
  },
  fileAClaim: {
    description: 'Fulfillment Planner File a Claim Label',
    defaultMessage: 'File a Claim',
    id: 'Ke522j',
  },
});
